import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconArrowUpRight(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 100 100"
      {...props}
    >
      <defs>
        <linearGradient
          id={`${iconUuid}_a`}
          x1={77.92}
          y1={73.43}
          x2={26.25}
          y2={21.75}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
      </defs>
      <polygon
        fill={`url(#${iconUuid}_a)`}
        stroke={`url(#${iconUuid}_a)`}
        strokeWidth={5}
        points="80.61 70.74 80.53 19.15 28.93 19.07 28.93 20.57 77.69 20.64 22.98 75.36 24.04 76.42 79.03 21.43 79.11 70.74 80.61 70.74"
      />
    </svg>
  );
}
export default SvgEchIconArrowUpRight;
